var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("\n    解答速報 2020（非公式）\n  ")]),_c('v-spacer'),_vm._v("\n\n  ドット会 with 数研\n\n  ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }